import React from 'react';
import { IconButton, Tooltip, useTheme as useMuiTheme } from '@mui/material';
import { useTheme } from './ThemeProvider';

export const ThemeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();
  const muiTheme = useMuiTheme(); // Get the MUI theme for color values

  return (
    <Tooltip title={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}>
      <IconButton
        onClick={toggleTheme}
        color="inherit"
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
        sx={{
          color: isDarkMode 
            ? muiTheme.palette.grey[300] 
            : muiTheme.palette.primary.main, // Use primary color in light mode for visibility
          '&:hover': {
            backgroundColor: isDarkMode
              ? 'rgba(255, 255, 255, 0.05)'
              : 'rgba(0, 0, 0, 0.04)',
          }
        }}
      >
        {isDarkMode 
          ? <span className="material-symbols-outlined" style={{ fontSize: '1.25rem' }}>wb_sunny</span> 
          : <span className="material-symbols-outlined" style={{ fontSize: '1.25rem' }}>nightlight</span>}
      </IconButton>
    </Tooltip>
  );
}; 